import type { DropdownData } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { list } from '../../../../../common/classes/request-builder';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';

export class CamposListsDefinition {
  public fincas: DropdownData<FincasModel> = list<FincasModel>();
      public parcelas: DropdownData<ParcelasModel> = list<ParcelasModel>();
      public cultivos: DropdownData<VisitasVariedadMesModel> = list<VisitasVariedadMesModel>();
      public variedades: DropdownData<VisitasVariedadMesModel> = list<VisitasVariedadMesModel>();
  
      public patron: DropdownData<string> = list<string>(
          ['...', null]
      );
  
      public patronAlmendro: DropdownData<string> = list<string>(
          ['...', null],
          'Franco de semilla'
      );
      public patronManzano: DropdownData<string> = list<string>(
          ['...', null],
          // Fuji
          'Kiku',
          'Fubrax',
          'Zhen Aztec',
          'San',
          'September Wonder',
          // Gala
          'Brookfield',
          'Scniga',
          'Vinus',
          'Schnicored',
          // Golden'
          'Delicious',
          'Smoothee',
          'Reinders',
          'Parsi',
          // Granny Smith
          'Challenger',
          // Red Delicious
          'Starking',
          'Golden Rose',
          'Jeromine',
          'Scarlet Spur',
          // Reineta
          'Blanca',
          'Parda',
          // Otros patrones
          'M12',
          'M7',
          'M9',
          'MM106'
      );
      public patronMelocotonero: DropdownData<string> = list(
          ['...', null],
          'GF-677', 'GxN Garnem', 'Monclart'
      );
      public patronCerezo: DropdownData<string> = list(
          ['...', null],
          'Adara', 'Avium', 'Cab6', 'Col', 'Marina-Adara', 'Maxma', 'Santa Lucía', 'Santa Lucía 64'
      );
      public patronCiruelo: DropdownData<string> = list(
          ['...', null],
          'Mariana', 'Melocotonero', 'Mirobolán C'
      );
      public patronCitricos: DropdownData<string> = list(
          ['...', null],
          'Carrizo', 'Cleopatra', 'Forner Alcaide', 'Macrophylla', 'Naranjo Borde', 'Volkameriana',
      );
      public patronPera: DropdownData<string> = list(
          ['...', null],
          'BA-29', 'EM-C', 'Franco', 'Membrillero'
      );
      public patronVina: DropdownData<string> = list( // Portainjerto
          ['...', null],
          'R110', '1103/P', 'RU/140', 'SO4', 'M1', 'M2', 'M3', 'M4'
      );
}